export default class MTemplate
{
	constructor(el)
	{
		this.el = el;
	}

	getElement()
	{
		let div = document.createElement('div');
		div.innerHTML = this.el.innerHTML;

		return div;
	}
}
